var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510.7 510.7",
    height: 512,
    viewBox: "0 0 510.7 510.7",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m478.182 239.16c-34.921 34.921-97.672 37.158-146.26 27.37-3.53-.69-6.26-1.37-12.63-2.83-33.083-143.233 37.06-217.237 183.42-183.42 12.424 51.781 12.95 121.398-24.53 158.88z",
    fill: "#00aa95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.412 263.7c-6.43 1.48-9.15 2.15-12.73 2.85-48.748 9.664-111.145 7.625-146.16-27.39-37.529-37.529-36.934-107.283-24.531-158.88 52.091-12.007 120.923-13.385 158.88 24.53 37.876 37.875 36.559 106.759 24.541 158.89z",
    fill: "#00cc76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.292 129.7c0 53.477-49.481 101.233-95 129.7-56.619-35.709-110.195-93.069-90.86-156.82 12.808-42.403 53.331-79.064 90.86-102.58 45.294 27.93 95 76.468 95 129.7z",
    fill: "#a5e887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.292 129.7c0 53.601-49.709 101.376-95 129.7-1.884-1.188-1.163-.736-3.14-1.97v-255.43c.8-.52 1.6-1.03 2.39-1.53.944-.592.484-.638 2.09.37 44.804 28.364 93.66 75.781 93.66 128.86z",
    fill: "#00cc76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.872 330.49c-82.271-79.475-53.619-51.798-119.87-115.79h-109.88c-4.66-9.28-8.07-19.4-10.42-30h89.24l-89.61-86.56c1.05-6.14 2.28-12.12 3.66-17.86 5.64-1.3 11.47-2.47 17.43-3.48l78.87 76.19v-77.62c10.48 1.75 20.58 4.46 30 8.29v98.31c96.413 93.132 103.821 100.286 121 116.88z",
    fill: "#a5e887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.642 184.7h89.36c-2.35 10.6-5.76 20.72-10.41 30h-110.01c-65.888 63.641-37.997 36.699-119.08 115.03v-41.71c68.678-66.341 39.754-38.402 109.79-106.05v-98.26c9.42-3.85 19.52-6.56 30-8.32v77.6l78.89-76.21c6 1.02 11.86 2.19 17.53 3.5 1.37 5.71 2.6 11.65 3.64 17.76z",
    fill: "#00cc76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.292 375.7h-30c0-10.788 0-193.685 0-205.17-59.23-32.91-46.51-25.84-64.28-35.72 7.05-12.69 3.84-6.92 14.56-26.22l49.72 27.62v-126.19c7.416-5.259 14.859-10.018 15.06-9.96.354.089 8.755 5.566 14.94 9.96v89.68l40-30 18 24-58 43.5z",
    fill: "#00cc76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.292 375.7h-14.94v-375.64c.354.089 8.755 5.566 14.94 9.96v89.68l40-30 18 24-58 43.5z",
    fill: "#00aa95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.292 487.7c0 5.889-.375 8.23-2 23h-394l-1.47-13.36c-7.305-66.563 60.218-116.016 121.1-89.48 32.285-62.72 122.39-62.845 154.74 0 56.819-24.765 121.63 16.948 121.63 79.84z",
    fill: "#c47e4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.292 487.7c0 5.889-.375 8.23-2 23h-197v-150c33.09 0 62.71 18.68 77.37 47.16 56.819-24.765 121.63 16.948 121.63 79.84z",
    fill: "#a05f4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCrop);
export default __webpack_public_path__ + "static/media/default-crop.8edb4ad3e077af13c4eed881943d3875.svg";
export { ForwardRef as ReactComponent };